module.exports = __webpack_public_path__ + "img/busstop_off.12fe9f18.svg";